const GRADE_LIBRARY = {
  1: {
    topics: [
      { title: 'Contagem e leitura de números até 100', unitTheme: 'Números', skillReference: 'EF01MA01', competenceTitle: 'Explorar números em diferentes contextos do cotidiano.', skillTitle: 'Contar, ler, escrever e comparar números naturais até 100.', learningObjectives: 'Ler, ordenar, comparar e representar quantidades com apoio concreto e visual.' },
      { title: 'Adição e subtração até 20', unitTheme: 'Números', skillReference: 'EF01MA06', competenceTitle: 'Resolver problemas de juntar, acrescentar, separar e retirar.', skillTitle: 'Resolver situações-problema de adição e subtração com estratégias pessoais.', learningObjectives: 'Usar desenho, material dourado, contagem e cálculo mental inicial.' },
      { title: 'Sequências e padrões', unitTheme: 'Álgebra', skillReference: 'EF01MA10', competenceTitle: 'Reconhecer regularidades em sequências do cotidiano.', skillTitle: 'Identificar, descrever e completar padrões repetitivos e recursivos.', learningObjectives: 'Perceber regularidades e prever próximos elementos.' },
      { title: 'Formas geométricas do cotidiano', unitTheme: 'Geometria', skillReference: 'EF01MA14', competenceTitle: 'Relacionar formas espaciais e planas ao mundo real.', skillTitle: 'Identificar figuras geométricas em objetos e desenhos.', learningObjectives: 'Nomear, comparar e montar figuras com materiais concretos.' }
    ]
  },
  2: {
    topics: [
      { title: 'Adição e subtração com reagrupamento', unitTheme: 'Números', skillReference: 'EF02MA05', competenceTitle: 'Ampliar repertório de cálculo em contextos variados.', skillTitle: 'Resolver problemas de adição e subtração com e sem reagrupamento.', learningObjectives: 'Explicar estratégias usando registros pessoais e convencionais.' },
      { title: 'Sistema monetário brasileiro', unitTheme: 'Grandezas e Medidas', skillReference: 'EF02MA20', competenceTitle: 'Relacionar matemática com situações de compra e troca.', skillTitle: 'Reconhecer e usar cédulas e moedas em situações-problema.', learningObjectives: 'Compor valores, comparar preços e calcular troco simples.' },
      { title: 'Multiplicação por adições iguais', unitTheme: 'Números', skillReference: 'EF02MA07', competenceTitle: 'Construir a ideia de grupos iguais.', skillTitle: 'Resolver problemas de dobro, metade e agrupamentos.', learningObjectives: 'Representar multiplicação inicial com desenhos, materiais e frases matemáticas.' },
      { title: 'Localização e mapas simples', unitTheme: 'Geometria', skillReference: 'EF02MA12', competenceTitle: 'Descrever deslocamentos e posições no espaço.', skillTitle: 'Usar referências para localizar pessoas e objetos.', learningObjectives: 'Ler mapas simples e registrar percursos com setas e comandos.' }
    ]
  },
  3: {
    topics: [
      { title: 'Multiplicação por agrupamentos', unitTheme: 'Números', skillReference: 'EF03MA03', competenceTitle: 'Compreender multiplicação como grupos iguais e proporcionalidade inicial.', skillTitle: 'Resolver problemas de multiplicação e divisão simples.', learningObjectives: 'Representar grupos iguais, repartir e comparar quantidades.' },
      { title: 'Divisão e repartição', unitTheme: 'Números', skillReference: 'EF03MA04', competenceTitle: 'Relacionar repartir, medir e distribuir.', skillTitle: 'Resolver problemas de divisão em repartições equitativas e medidas.', learningObjectives: 'Explicar estratégias com desenhos, tabelas e materiais.' },
      { title: 'Frações simples', unitTheme: 'Números', skillReference: 'EF03MA09', competenceTitle: 'Reconhecer parte-todo em situações concretas.', skillTitle: 'Identificar frações unitárias em figuras e objetos.', learningObjectives: 'Relacionar metade, terça parte e quarta parte ao cotidiano.' },
      { title: 'Perímetro em malhas', unitTheme: 'Grandezas e Medidas', skillReference: 'EF03MA16', competenceTitle: 'Medir e comparar comprimentos em contornos.', skillTitle: 'Determinar o perímetro de figuras em malha quadriculada.', learningObjectives: 'Contar lados, unidades e comparar caminhos.' }
    ]
  },
  4: {
    topics: [
      { title: 'Números maiores e decomposição', unitTheme: 'Números', skillReference: 'EF04MA01', competenceTitle: 'Ler e escrever números naturais em diferentes ordens.', skillTitle: 'Compor e decompor números naturais com apoio de ordens e classes.', learningObjectives: 'Representar milhares, centenas, dezenas e unidades.' },
      { title: 'Padrões e coordenadas', unitTheme: 'Álgebra e Geometria', skillReference: 'EF04MA11', competenceTitle: 'Relacionar regularidades e localização espacial.', skillTitle: 'Descrever padrões e localizar pontos em malhas e mapas.', learningObjectives: 'Completar sequências, usar pares ordenados e percursos.' },
      { title: 'Perímetro e área', unitTheme: 'Grandezas e Medidas', skillReference: 'EF04MA20', competenceTitle: 'Comparar medidas de contorno e superfície.', skillTitle: 'Calcular perímetro e estimar área de figuras planas.', learningObjectives: 'Usar malha quadriculada e decomposição de formas.' },
      { title: 'Divisão com estratégias pessoais', unitTheme: 'Números', skillReference: 'EF04MA07', competenceTitle: 'Usar diferentes estratégias de cálculo e estimativa.', skillTitle: 'Resolver divisões com resto e discutir significados.', learningObjectives: 'Relacionar divisão, multiplicação e verificação do resultado.' }
    ]
  },
  5: {
    topics: [
      { title: 'Frações equivalentes', unitTheme: 'Números', skillReference: 'EF05MA07', competenceTitle: 'Compreender frações em diferentes representações.', skillTitle: 'Reconhecer e produzir frações equivalentes.', learningObjectives: 'Comparar, simplificar e representar frações em figuras e reta numérica.' },
      { title: 'Números decimais e dinheiro', unitTheme: 'Números', skillReference: 'EF05MA08', competenceTitle: 'Relacionar decimais a medidas e sistema monetário.', skillTitle: 'Ler, escrever e comparar números decimais.', learningObjectives: 'Resolver problemas de compras, medidas e comparações.' },
      { title: 'Volume e capacidade', unitTheme: 'Grandezas e Medidas', skillReference: 'EF05MA19', competenceTitle: 'Investigar grandezas mensuráveis em recipientes e objetos.', skillTitle: 'Comparar volume e capacidade em situações cotidianas.', learningObjectives: 'Estimar, medir e explicar equivalências simples.' },
      { title: 'Probabilidade inicial', unitTheme: 'Probabilidade e Estatística', skillReference: 'EF05MA22', competenceTitle: 'Analisar possibilidades em experimentos simples.', skillTitle: 'Classificar eventos como certos, prováveis ou impossíveis.', learningObjectives: 'Justificar previsões com base em dados e experimentação.' }
    ]
  },
  6: {
    topics: [
      { title: 'Razão e porcentagem', unitTheme: 'Números', skillReference: 'EF06MA13', competenceTitle: 'Interpretar relações multiplicativas em contextos reais.', skillTitle: 'Resolver problemas envolvendo razão, taxa e porcentagem.', learningObjectives: 'Usar tabelas, escalas e equivalências para argumentar.' },
      { title: 'Operações com frações', unitTheme: 'Números', skillReference: 'EF06MA09', competenceTitle: 'Ampliar repertório de cálculo com números racionais.', skillTitle: 'Resolver e elaborar problemas com frações.', learningObjectives: 'Comparar estratégias por desenhos, MMC e equivalências.' },
      { title: 'Plano cartesiano', unitTheme: 'Geometria', skillReference: 'EF06MA16', competenceTitle: 'Ler e construir representações no plano.', skillTitle: 'Localizar e representar pontos no plano cartesiano.', learningObjectives: 'Interpretar pares ordenados, deslocamentos e trajetórias.' },
      { title: 'Leitura de gráficos e tabelas', unitTheme: 'Probabilidade e Estatística', skillReference: 'EF06MA31', competenceTitle: 'Interpretar dados em tabelas e gráficos.', skillTitle: 'Resolver problemas com organização e leitura de dados.', learningObjectives: 'Comparar tendências, frequências e conclusões.' }
    ]
  },
  7: {
    topics: [
      { title: 'Expressões algébricas', unitTheme: 'Álgebra', skillReference: 'EF07MA13', competenceTitle: 'Generalizar padrões e descrever relações.', skillTitle: 'Utilizar linguagem algébrica para expressar regularidades.', learningObjectives: 'Substituir valores, simplificar expressões e justificar regras.' },
      { title: 'Equações simples e problemas', unitTheme: 'Álgebra', skillReference: 'EF07MA14', competenceTitle: 'Resolver problemas usando igualdade e incógnita.', skillTitle: 'Resolver equações do 1º grau em contextos variados.', learningObjectives: 'Analisar passos, conferir soluções e comparar métodos.' },
      { title: 'Proporcionalidade e escalas', unitTheme: 'Números', skillReference: 'EF07MA18', competenceTitle: 'Modelar relações proporcionais em mapas, receitas e ampliações.', skillTitle: 'Resolver problemas de proporcionalidade direta.', learningObjectives: 'Usar regra de três, tabelas e fator de escala.' },
      { title: 'Polígonos e ângulos', unitTheme: 'Geometria', skillReference: 'EF07MA24', competenceTitle: 'Investigar propriedades de figuras planas.', skillTitle: 'Relacionar lados, ângulos e regularidades em polígonos.', learningObjectives: 'Classificar figuras e justificar medidas.' }
    ]
  },
  8: {
    topics: [
      { title: 'Equação do 1º grau', unitTheme: 'Álgebra', skillReference: 'EF08MA06', competenceTitle: 'Modelar e resolver situações por equações lineares.', skillTitle: 'Resolver e elaborar problemas que possam ser representados por equações do 1º grau.', learningObjectives: 'Representar, resolver, verificar e comparar métodos nacionais e internacionais.' },
      { title: 'Sistemas de equações', unitTheme: 'Álgebra', skillReference: 'EF08MA08', competenceTitle: 'Analisar relações entre duas variáveis.', skillTitle: 'Resolver sistemas lineares simples em situações-problema.', learningObjectives: 'Comparar métodos algébricos, gráficos e tabelares.' },
      { title: 'Transformações geométricas', unitTheme: 'Geometria', skillReference: 'EF08MA18', competenceTitle: 'Reconhecer simetrias e transformações no plano.', skillTitle: 'Identificar translações, rotações e reflexões.', learningObjectives: 'Produzir composições visuais e argumentar sobre invariantes.' },
      { title: 'Estatística e média', unitTheme: 'Probabilidade e Estatística', skillReference: 'EF08MA24', competenceTitle: 'Analisar dados e medidas de tendência central.', skillTitle: 'Interpretar média, moda e mediana em conjuntos de dados.', learningObjectives: 'Tomar decisões com base em tabelas, gráficos e resumos estatísticos.' }
    ]
  },
  9: {
    topics: [
      { title: 'Função afim e dados', unitTheme: 'Álgebra', skillReference: 'EF09MA07', competenceTitle: 'Relacionar grandezas por modelos lineares.', skillTitle: 'Interpretar e representar funções afins em tabelas, gráficos e expressões.', learningObjectives: 'Analisar taxa de variação, interceptos e aplicações em situações reais.' },
      { title: 'Teorema de Pitágoras', unitTheme: 'Geometria', skillReference: 'EF09MA14', competenceTitle: 'Resolver problemas geométricos com relações métricas.', skillTitle: 'Aplicar o teorema de Pitágoras em triângulos retângulos.', learningObjectives: 'Usar desenho, cálculo e verificação em contextos do cotidiano.' },
      { title: 'Probabilidade simples', unitTheme: 'Probabilidade e Estatística', skillReference: 'EF09MA22', competenceTitle: 'Avaliar chances e decisões em experimentos aleatórios.', skillTitle: 'Resolver problemas de probabilidade simples.', learningObjectives: 'Comparar resultados experimentais e teóricos.' },
      { title: 'Planejamento financeiro', unitTheme: 'Números', skillReference: 'EF09MA05', competenceTitle: 'Analisar porcentagens, juros e consumo consciente.', skillTitle: 'Resolver problemas envolvendo porcentagens e juros simples.', learningObjectives: 'Interpretar planilhas, simulações e cenários de decisão.' }
    ]
  }
}

const DIMENSION_META = {
  regular: { label: 'Ensino regular', methodology: 'Resolução guiada e estratégias flexíveis' },
  adapted: { label: 'Ensino adaptado', methodology: 'ABA, material dourado e apoios visuais' },
  blocks: { label: 'Programação em blocos', methodology: 'Pensamento computacional com blocos' },
  games: { label: 'Games em Python', methodology: 'Desafios matemáticos em jogos' }
}


function supportProfileText(profile = 'geral') {
  const profiles = {
    TEA: 'Rotina previsível, uma instrução por vez, pistas visuais e poucos estímulos simultâneos.',
    TDAH: 'Etapas curtas, objetivo visível, feedback imediato, pausas breves e reforço por conclusão.',
    TOC: 'Início e fim claros, limite de conferências, linguagem objetiva e encerramento explícito da tarefa.',
    Down: 'Linguagem simples, modelagem concreta, repetição positiva, tempo ampliado e progressão gradual.',
    outros: 'Ajuste de linguagem, tempo, quantidade de estímulos e forma de resposta conforme a necessidade do estudante.',
    geral: 'Partir do concreto, usar apoio visual e permitir explicação verbal, desenho ou registro simbólico.'
  }
  return profiles[profile] || profiles.geral
}

function gameStarter({ grade, topic, exerciseNumber, supportProfile = 'geral' }) {
  const a = Math.max(1, Number(grade) + Number(exerciseNumber))
  const b = Math.max(1, Number(grade) + 1)
  const expected = a + b
  return `# ${grade}º ano • ${topic}
# Perfil: ${supportProfile}
# ${supportProfileText(supportProfile)}
score = 0
resposta_esperada = ${expected}
print("Missão: ${topic}")
print("Calcule ${a} + ${b} e altere resposta_aluno se quiser testar outra tentativa.")
resposta_aluno = ${a} + ${b}
if resposta_aluno == resposta_esperada:
    score += 10
    print("✅ Acertou! Pontos:", score)
else:
    print("🔁 Tente novamente usando outra estratégia.")
print("Resposta esperada:", resposta_esperada)`
}

function slugify(input) {
  return String(input)
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)/g, '')
}

export function getGradeTopics(grade) {
  return GRADE_LIBRARY[grade]?.topics || []
}

export function getBnccForGrade(grade) {
  return getGradeTopics(grade).map((topic, index) => ({
    id: `${grade}-${index + 1}`,
    grade,
    subject: 'Matemática',
    unitTheme: topic.unitTheme,
    competenceTitle: topic.competenceTitle,
    skillTitle: topic.skillTitle,
    skillReference: topic.skillReference,
    learningObjectives: topic.learningObjectives,
    title: topic.title
  }))
}

export function getFallbackCatalog(grade = null) {
  const grades = grade ? [grade] : Object.keys(GRADE_LIBRARY).map(Number)
  return grades.flatMap((currentGrade) =>
    getGradeTopics(currentGrade).flatMap((topic, index) =>
      Object.entries(DIMENSION_META).map(([dimension, meta]) => ({
        id: `fallback-${currentGrade}-${slugify(topic.title)}-${dimension}`,
        title: `${currentGrade}º ano • ${topic.title} • ${meta.label}`,
        slug: `fallback-${currentGrade}-${slugify(topic.title)}-${dimension}`,
        grade: currentGrade,
        subject: 'Matemática',
        topic: topic.title,
        dimension,
        methodology: meta.methodology,
        summary: `Módulo alinhado à BNCC para o ${currentGrade}º ano com foco em ${topic.title.toLowerCase()}.`,
        teacherNotes: `Competência ${topic.skillReference}. Trabalhe do concreto ao simbólico e registre a estratégia do estudante.`,
        estimatedMinutes: currentGrade <= 3 ? 35 : currentGrade <= 6 ? 45 : 55,
        unitTheme: topic.unitTheme,
        competenceTitle: topic.competenceTitle,
        skillTitle: topic.skillTitle,
        skillReference: topic.skillReference,
        learningObjectives: topic.learningObjectives,
        exerciseCount: 10,
        source: 'fallback',
        orderIndex: index + 1
      }))
    )
  )
}

function buildExercise({ grade, topic, dimension, exerciseNumber, supportProfile = 'geral' }) {
  const base = {
    id: `${slugify(topic)}-${dimension}-${exerciseNumber}`,
    exerciseNumber,
    title: `${topic} • exercício ${exerciseNumber}`,
    prompt: grade <= 2
      ? `Resolva a tarefa ${exerciseNumber} de ${topic.toLowerCase()} usando desenho, fala e material concreto.`
      : `Resolva a situação ${exerciseNumber} de ${topic.toLowerCase()} explicando a estratégia usada.`
  }
  if (dimension === 'adapted') {
    return {
      ...base,
      supportStrategy: `Aplicar antecedente claro, prompt mínimo necessário, reforço positivo e generalização. ${supportProfileText(supportProfile)}`,
      regularSolution: 'Resolver em microetapas com modelo e retirada gradual de ajuda.',
      alternativeSolution: 'Usar material dourado, cartões visuais, pareamento e escolha entre opções.',
      blocksSolution: 'Representar cada passo como bloco: observar → agrupar → registrar → conferir.',
      gameChallenge: `Criar fase curta e previsível sobre ${topic.toLowerCase()} com reforço imediato.`,
      starterCode: `const supports = ['roteiro visual', 'material dourado', 'reforço positivo'];\nconsole.log('Apoios ativos:', supports.join(', '));`,
      answerPattern: 'open'
    }
  }
  if (dimension === 'blocks') {
    return {
      ...base,
      supportStrategy: `Organizar o raciocínio em sequência, repetição, decisão e validação. ${supportProfileText(supportProfile)}`,
      regularSolution: 'Planejar entrada, processo e saída do algoritmo.',
      alternativeSolution: 'Descrever o algoritmo em linguagem natural antes de montar blocos.',
      blocksSolution: 'Blocos sugeridos: iniciar → repetir → calcular → mostrar → verificar.',
      gameChallenge: `Montar missão em blocos para resolver ${topic.toLowerCase()} antes de abrir a próxima fase.`,
      starterCode: `const bloco = ['iniciar', 'calcular', 'mostrar'];\nconsole.log('Sequência lógica:', bloco.join(' -> '));`,
      answerPattern: 'algorithm'
    }
  }
  if (dimension === 'games') {
    return {
      ...base,
      supportStrategy: `Separar a lógica matemática da regra do jogo e da condição de vitória. ${supportProfileText(supportProfile)}`,
      regularSolution: 'Definir variáveis, desafio, pontuação e feedback.',
      alternativeSolution: 'Criar duas formas de vencer: cálculo direto ou estratégia visual/tabelar.',
      blocksSolution: 'Esboçar a lógica em blocos antes da versão em Python.',
      gameChallenge: `Programar uma fase em Python em que o jogador use ${topic.toLowerCase()} para pontuar.`,
      starterCode: gameStarter({ grade, topic, exerciseNumber, supportProfile }),
      answerPattern: 'code'
    }
  }
  return {
    ...base,
    supportStrategy: `Partir do concreto, passar pelo desenho e chegar ao registro simbólico. ${supportProfileText(supportProfile)}`,
    regularSolution: 'Identificar dados, escolher estratégia, resolver, conferir e justificar.',
    alternativeSolution: grade >= 5
      ? 'Comparar solução tradicional com métodos de Singapura, Japão, Finlândia, China ou reta numérica.'
      : 'Usar completamento, decomposição, contagem em saltos e esquemas visuais.',
    blocksSolution: 'Modelar o pensamento em etapas e depois converter em blocos.',
    gameChallenge: `Transformar ${topic.toLowerCase()} em uma mecânica simples de jogo com metas e fases.`,
    starterCode: `const etapa = { resolvida: false, tentativas: 0 };\netapa.tentativas += 1;\nconsole.log('Registrar solução de ${topic.toLowerCase()}', etapa);`,
    answerPattern: 'open'
  }
}

export function getFallbackModule(moduleId, count = 10, supportProfile = 'geral') {
  const catalog = getFallbackCatalog()
  const module = catalog.find((item) => item.id === moduleId)
  if (!module) return null
  const exercises = Array.from({ length: count }, (_, index) => buildExercise({ grade: module.grade, topic: module.topic, dimension: module.dimension, exerciseNumber: index + 1, supportProfile }))
  return { module: { ...module, exerciseCount: count }, exercises, total: exercises.length }
}

export function generateLocalModules({ grade, topic, requestedCount = 10, supportProfile = 'geral' }) {
  const modules = Object.keys(DIMENSION_META).map((dimension) => {
    const moduleId = `generated-${grade}-${slugify(topic)}-${dimension}-${requestedCount}`
    return {
      ...getFallbackCatalog(grade).find((item) => item.topic === topic && item.dimension === dimension),
      id: moduleId,
      slug: moduleId,
      source: 'generated',
      exerciseCount: requestedCount,
      title: `${grade}º ano • ${topic} • ${DIMENSION_META[dimension].label}`,
      summary: `Conteúdo gerado localmente com ${requestedCount} exercícios alinhados à BNCC para ${topic.toLowerCase()}.`
    }
  })
  return {
    modules,
    moduleMap: Object.fromEntries(modules.map((item) => [item.id, { module: item, exercises: Array.from({ length: requestedCount }, (_, index) => buildExercise({ grade, topic, dimension: item.dimension, exerciseNumber: index + 1, supportProfile })) }]))
  }
}

export function getFallbackActivities() {
  return getFallbackCatalog().filter((module) => ['regular', 'adapted', 'blocks', 'games'].includes(module.dimension)).map((module, index) => ({
    id: module.id,
    title: module.title,
    description: module.summary,
    type: module.dimension === 'games' ? 'game' : module.dimension === 'blocks' ? 'blockly' : 'practice',
    category: module.unitTheme,
    grade: module.grade,
    difficulty: module.grade <= 3 ? 'easy' : module.grade <= 6 ? 'medium' : 'hard',
    accessLevel: module.grade <= 2 ? 'free' : module.grade <= 5 ? 'basic' : 'regular',
    durationMinutes: module.estimatedMinutes,
    estimatedScore: 100,
    objective: module.learningObjectives,
    guidance: module.teacherNotes,
    learningDimensions: module.dimension === 'regular'
      ? ['ensino-regular', 'adaptado', 'programacao', 'games']
      : module.dimension === 'adapted'
        ? ['adaptado', 'ensino-regular']
        : module.dimension === 'blocks'
          ? ['programacao']
          : ['games'],
    supportNeeds: ['TEA', 'TDAH', 'TOC', 'Down', 'outros'],
    adaptations: module.dimension === 'adapted'
      ? ['Dividir em microetapas.', 'Usar reforço positivo.', 'Aplicar material dourado e pistas visuais.']
      : ['Permitir solução desenhada.', 'Verbalizar a estratégia.', 'Checar a resposta com outra abordagem.'],
    resources: module.dimension === 'blocks'
      ? ['editor de blocos', 'roteiro visual', 'quadro de comandos']
      : module.dimension === 'games'
        ? ['editor Python', 'runner local', 'missões por fase']
        : ['material dourado', 'caderno', 'cartões visuais'],
    tags: [module.topic, module.dimension, module.skillReference],
    orderIndex: index + 1,
    source: module.source
  }))
}

export function getFallbackProfessionals() {
  return [
    { id: 'fallback-prof-1', name: 'Dra. Ana Santos', specialty: 'Psicóloga Infantil', specialization: 'TEA, TDAH e aprendizagem matemática', bio: 'Atendimento on-line com anamnese opcional, apoio emocional e planejamento de intervenção.', rating: 4.9, reviews: 28, hourlyRate: 150, verified: true, onlineSupport: true },
    { id: 'fallback-prof-2', name: 'Prof. Lucas Lima', specialty: 'Psicopedagogo', specialization: 'BNCC, material dourado e ensino adaptado', bio: 'Integra conteúdos regulares, ABA, programação em blocos e games em rotinas estruturadas.', rating: 4.8, reviews: 19, hourlyRate: 140, verified: true, onlineSupport: true },
    { id: 'fallback-prof-3', name: 'Dra. Carla Oliveira', specialty: 'Psicopedagoga Clínica', specialization: 'Anamnese, regulação e matemática funcional', bio: 'Trabalha com famílias e escolas para planejar trilhas com mediação concreta e feedback contínuo.', rating: 4.7, reviews: 15, hourlyRate: 135, verified: true, onlineSupport: true }
  ]
}
